<template>
  <div v-if="attachments.length > 0 || warning" class="flex flex-col gap-2">
    <div v-if="attachments.length > 0" class="flex gap-2">
      <div v-for="(att, idx) in attachments" :key="idx" class="group relative">
        <img
          :src="att.previewUrl"
          class="size-16 rounded-md border border-gray-200 object-cover"
          alt="Pending attachment"
        />
        <button
          class="absolute -top-1 -right-1 flex size-4 items-center justify-center rounded-full bg-red-500 text-[10px] text-white hover:bg-red-600"
          @click="emit('remove', idx)"
        >
          &times;
        </button>
        <div
          v-if="att.uploading"
          class="absolute inset-0 flex items-center justify-center rounded-md bg-black/40"
        >
          <Icon
            name="spinner-third-duotone"
            class="size-4 animate-spin text-white"
          />
        </div>
        <div
          v-if="att.error"
          class="absolute inset-0 flex flex-col items-center justify-center rounded-md bg-red-500/60"
          :title="att.error"
        >
          <Icon name="times-circle" class="size-4 text-white" />
          <span class="mt-0.5 text-[9px] leading-tight text-white">Failed</span>
        </div>
      </div>
    </div>
    <p v-if="warning" class="text-xs text-orange-700">
      {{ warning }}
    </p>
  </div>
</template>

<script setup lang="ts">
import type { PropType } from "vue";
import type { PendingAttachment } from "@/composables/usePendingAttachments";
import Icon from "@/components/Core/Icon.vue";

defineProps({
  attachments: {
    type: Array as PropType<PendingAttachment[]>,
    required: true,
  },
  warning: {
    type: String as PropType<string | null>,
    default: null,
  },
});

const emit = defineEmits({
  remove: (_index: number) => true,
});
</script>
